module.exports = __webpack_public_path__ + "img/health_insurance.9211bcb.svg";